
  // Rebuilt TransportationItem styled and structured similar to PalletItem, but adapted to transportation interface

  import React, { useState, useRef } from "react";
  import styled from "styled-components";
  import { ITransportationCompany, ITransportationGrower, ITransportationOrderDetail } from "../../../../../../modules/API/Seller/models/transportation";
import TitleLayout from "../../../kosherTeudot/generic/TitleLayout";
import TitleRow from "../../../kosherTeudot/generic/TitleRow";
import TitleRowItem from "../../../kosherTeudot/generic/TitleRowItem";
import AppleIcon from "../../../../../../generic/icons/IconLib/AppleIcon";
import PalletIcon from "../../../../../../generic/icons/IconLib/PalletIcon";
import ScalesIcon from "../../../../../../generic/icons/IconLib/ScaleIcon";
import SpeedIcon from "../../../../../../generic/icons/IconLib/TruckIcon";
import UserIcon from "../../../../../../generic/icons/IconLib/UserIcon";
import ProductImage from "../../../queries/TeudotDetails/Components/ProductImage";
import DropdownWrapper from "./ui/DropdownWrapper";
import SectionWrapper from "./ui/SectionWrapper";

  interface ITransportationItemProps {
    company: ITransportationCompany;
    handlePrintByTransportation: (FreightCompanyID: number) => void;
  }

  const TransportationItem: React.FC<ITransportationItemProps> = ({ company, handlePrintByTransportation }) => {

    return (
     <DropdownWrapper
      title={company.FC_Name.trim()}
      icon={<SpeedIcon color="#297f76" />}
      handlePrint={() => handlePrintByTransportation(company.FC_ID)}
     >
       {company.Growers.map((grower) => (
        
           <SectionWrapper
            title={`מגדל: ${grower.GrowerName.trim()}`}
            icon={<></>}
           >
            <OrdersBody>
                {grower.OrderDetails.map((order, index) => (
                  <ItemRowWrapper key={order.RecID} $isOdd={index % 2 === 0}>
                      <SideImage>
                          <ProductImage  id={order.GeneralProductID}/>
                      </SideImage>
                  <TitleRow>
                    <TitleRowItem name={`${order.ProductDesc.trim()} ${order.VarietyDesc.trim()} ${order.SizeID.trim()}`} icon={<AppleIcon />} />
                  </TitleRow>
                  <TitleRow>
                    <TitleRowItem 
                      icon={<PalletIcon />}
                      name={`${order.Order_Pallets}`}
                    />
                  </TitleRow>
                  <TitleRow>
                    <TitleRowItem name={`${order.Customer_Name.trim()}`} icon={<UserIcon />} />
                  </TitleRow>
                </ItemRowWrapper>
                ))}
              </OrdersBody>

           </SectionWrapper>
       ))}

     </DropdownWrapper>
    );
  };
 

  const OrdersBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5em;
  `;

  

  const ItemRowWrapper = styled.div<{$isOdd: boolean}>`
    position: relative;
    display: flex;
    flex-flow: column;
    gap: 0.2em;
    background-color: ${props => props.$isOdd ? '#f8f9fa' : '#fff'};
  `;
  const SideImage = styled.div`
    position: absolute;
    left: 0.2em;
    top: calc(50% - 1em);
    width: 2em;
    height: 2em;
  `;

  export default TransportationItem;